module.exports = __webpack_public_path__ + "img/BalFon.1a4a17a8.png";